import Breadcrumb from "components/Common/Breadcrumb2"
import toast from "components/Toast/Toast"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { Link, useHistory } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  Spinner,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import {
  deleteTransportadora,
  getAllShippingCompaniesParanoid,
  postNovaTransporadora,
  restoreTransportadora,
  updateTransportadora,
} from "services/shipping-companies/calls"
import SimpleBar from "simplebar-react"
import "simplebar-react/dist/simplebar.min.css"

const ListaTransportadoras = props => {
  document.title = "Eventos | Sensetek"

  const { t } = props

  const [isLoading, setLoading] = useState(true)
  const [shippingCompanies, setShippingCompanies] = useState([])
  const [novaTransp, setNovaTransp] = useState({ name: "", sla: "", tag: "" })
  const [updatedTransp, setUpdatedTransp] = useState({
    name: "",
    sla: "",
    tag: "",
  })
  const [modalUpdateTransp, setModalUpdateTransp] = useState(false)

  const [confirm, setConfirm] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)

  const history = useHistory()

  useEffect(() => {
    fetchAllShippingCompanies()
  }, [])

  const fetchAllShippingCompanies = async () => {
    try {
      const { payload } = await getAllShippingCompaniesParanoid()
      setShippingCompanies(payload.companies)
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const validaNovaTransp = () => {
    let errors = []
    if (!novaTransp?.name) {
      errors.push("Não é possível criar uma transportadora sem nome.")
    }
    if (!novaTransp?.sla) {
      errors.push("Não é possível criar uma transportadora sem sla.")
    }
    if (!novaTransp?.tag) {
      errors.push("Não é possível criar uma transportadora sem tag.")
    }
    if (errors?.length > 0) {
      return errors
    } else {
      return null
    }
  }

  const validaUpdateTransp = () => {
    let errors = []
    if (!updatedTransp?.name) {
      errors.push("Não é possível atualizar uma transportadora para sem nome.")
    }
    if (!updatedTransp?.sla) {
      errors.push("Não é possível atualizar uma transportadora para sem sla.")
    }
    if (!updatedTransp?.tag) {
      errors.push("Não é possível atualizar uma transportadora para sem tag.")
    }
    if (errors?.length > 0) {
      return errors
    } else {
      return null
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)
    try {
      const errors = validaNovaTransp()
      if (errors) {
        toast("warning", errors.join("<br />"))
        return
      }
      await postNovaTransporadora(novaTransp)
      toast("success", "Transportadora adicionada com sucesso!")
      fetchAllShippingCompanies()
      setNovaTransp({ name: "", sla: "", tag: "" })
    } catch (error) {
      console.error(error)
      toast("error", "Falha ao adicionar transportadora.", "Erro")
    } finally {
      setLoading(false)
    }
    return
  }

  const handleUpdateTransp = async e => {
    e.preventDefault()
    setLoading(true)
    try {
      const errors = validaUpdateTransp()
      if (errors) {
        toast("warning", errors.join("<br />"))
        return
      }
      await updateTransportadora(updatedTransp)
      toast("success", "Transportadora atualizada com sucesso!")
      fetchAllShippingCompanies()
      setUpdatedTransp({ name: "", sla: "", tag: "" })
      setModalUpdateTransp(false)
    } catch (error) {
      console.error(error)
      toast("error", "Falha ao atualizar transportadora.", "Erro")
    } finally {
      setLoading(false)
    }
    return
  }

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[{ title: props.t("Eventos"), path: "#" }]}
          />
          <Row>
            <Col>
              <Card className="mb-0 border-bottom">
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  {t("Adicionar")}
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col sm={6}>
                        <FormGroup>
                          <Label>{t("Nome da Transportadora")}</Label>
                          <Input
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder="Transportadora"
                            disabled={isLoading}
                            value={novaTransp.name}
                            onChange={e => {
                              setNovaTransp(old => {
                                return { ...old, name: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={2}>
                        <FormGroup>
                          <Label>{t("SLA da Transportadora")}</Label>
                          <Input
                            name="sla"
                            type="number"
                            className="form-control"
                            placeholder="SLA"
                            disabled={isLoading}
                            value={novaTransp.sla}
                            onChange={e => {
                              setNovaTransp(old => {
                                return { ...old, sla: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup>
                          <Label>{t("Tag da Transportadora")}</Label>
                          <Input
                            name="tag"
                            type="text"
                            className="form-control"
                            placeholder="Tag"
                            disabled={isLoading}
                            value={novaTransp.tag}
                            onChange={e => {
                              setNovaTransp(old => {
                                return { ...old, tag: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col className="d-flex align-items-end">
                        <FormGroup>
                          <Button type="submit">{t("Adicionar")}</Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  Eventos
                </CardHeader>
                <CardBody>
                  {isLoading && (
                    <div className="mt-3" style={{ textAlign: "center" }}>
                      <Spinner className="ms-2" color="primary" />
                    </div>
                  )}
                  {!isLoading && (
                    <Row>
                      <Col>
                        <SimpleBar style={{ overflowY: "hidden" }}>
                          <Table
                            striped={true}
                            className="table align-middle table-nowrap table-hover mb-0"
                          >
                            <thead>
                              <tr>
                                <th colSpan={1}>Nome</th>
                                <th colSpan={2}>SLA</th>
                              </tr>
                            </thead>
                            <tbody>
                              {shippingCompanies.length > 0 ? (
                                shippingCompanies.map(company => {
                                  return (
                                    <tr key={`agent-${company.id}`}>
                                      <td>{company.name}</td>
                                      <td>{company?.sla}</td>
                                      <td>
                                        <ul className="list-unstyled hstack gap-1 mb-0 flex-row-reverse">
                                          {!company?.deletedAt && (
                                            <li>
                                              <a
                                                target="_blank"
                                                className={`btn btn-sm btn-primary`}
                                                onClick={() => {
                                                  setUpdatedTransp(company)
                                                  setModalUpdateTransp(true)
                                                }}
                                              >
                                                <i
                                                  className="mdi mdi-account-edit"
                                                  id={`altToolTip${company.id}`}
                                                ></i>
                                              </a>
                                              <UncontrolledTooltip
                                                placement="top"
                                                target={`altToolTip${company.id}`}
                                              >
                                                Alterar
                                              </UncontrolledTooltip>
                                            </li>
                                          )}
                                          <li>
                                            <a
                                              target="_blank"
                                              className={`btn btn-sm btn-${
                                                company.deletedAt
                                                  ? "secondary"
                                                  : "danger"
                                              }`}
                                              onClick={async () => {
                                                if (company.deletedAt) {
                                                  try {
                                                    setLoading(true)
                                                    await restoreTransportadora(
                                                      company.id
                                                    )
                                                    fetchAllShippingCompanies()
                                                    toast(
                                                      "success",
                                                      "Transportadora ativada com sucesso!"
                                                    )
                                                  } catch (error) {
                                                    toast(
                                                      "warning",
                                                      "Falha ao ativar Transportadora."
                                                    )
                                                    console.log(error)
                                                  } finally {
                                                    setLoading(false)
                                                  }
                                                } else {
                                                  setConfirm({
                                                    title: "Confirmação",
                                                    body: (
                                                      <div>
                                                        <p>
                                                          Esta ação ira
                                                          desabilitar esta opção
                                                          de Transportadora.
                                                        </p>
                                                        <p>
                                                          Por favor, confirme se
                                                          tem certeza que deseja
                                                          desabilitar esta
                                                          Transportadora?
                                                        </p>
                                                      </div>
                                                    ),
                                                    onConfirm: async () => {
                                                      setLoading(true)
                                                      try {
                                                        await deleteTransportadora(
                                                          company.id
                                                        )
                                                        fetchAllShippingCompanies()
                                                        toast(
                                                          "success",
                                                          "Transportadora desativada com sucesso!"
                                                        )
                                                      } catch (error) {
                                                        toast(
                                                          "warning",
                                                          "Falha ao desativar Transportadora."
                                                        )
                                                        console.log(error)
                                                      } finally {
                                                        setLoading(false)
                                                      }
                                                    },
                                                  })
                                                  setShowConfirm(true)
                                                }
                                              }}
                                            >
                                              <i
                                                className={`mdi mdi-${
                                                  company.deletedAt
                                                    ? "account-reactivate"
                                                    : "delete-forever"
                                                }`}
                                                id={`delToolTip${company.id}`}
                                              ></i>
                                            </a>
                                            <UncontrolledTooltip
                                              placement="top"
                                              target={`delToolTip${company.id}`}
                                            >
                                              {`${
                                                company.deletedAt
                                                  ? "Reativar"
                                                  : "Desativar"
                                              }`}
                                            </UncontrolledTooltip>
                                          </li>
                                          <li>
                                            <Link
                                              to="#"
                                              className="btn btn-sm btn-soft-info"
                                              onClick={() => {
                                                history.push(
                                                  `/configuracoes/params/transportadoras/${company.id}`
                                                )
                                              }}
                                            >
                                              <i
                                                className="mdi mdi-eye-outline"
                                                id="edittooltip"
                                              />
                                              <UncontrolledTooltip
                                                placement="top"
                                                target="edittooltip"
                                              >
                                                Ver Eventos
                                              </UncontrolledTooltip>
                                            </Link>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr>
                                  <td colSpan="4" className="text-center">
                                    Nenhuma transportadora encontrada.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </SimpleBar>
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={async () => {
              await confirm?.onConfirm()
              setShowConfirm(false)
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={modalUpdateTransp}
        toggle={() => {
          setModalUpdateTransp(!modalUpdateTransp)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>Atualizar Transportadora</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setModalUpdateTransp(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleUpdateTransp} id="updateTransp">
            <Row>
              <Col>
                <FormGroup>
                  <Label>{t("Nome da Transportadora")}</Label>
                  <Input
                    name="name"
                    type="text"
                    className="form-control"
                    placeholder="Transportadora"
                    disabled={isLoading}
                    value={updatedTransp.name}
                    onChange={e => {
                      setUpdatedTransp(old => {
                        return { ...old, name: e.target.value }
                      })
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <FormGroup>
                  <Label>{t("SLA")}</Label>
                  <Input
                    name="name"
                    type="text"
                    className="form-control"
                    placeholder="Transportadora"
                    disabled={isLoading}
                    value={updatedTransp.sla}
                    onChange={e => {
                      setUpdatedTransp(old => {
                        return { ...old, sla: e.target.value }
                      })
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <FormGroup>
                  <Label>{t("TAG")}</Label>
                  <Input
                    name="name"
                    type="text"
                    className="form-control"
                    placeholder="Transportadora"
                    disabled={isLoading}
                    value={updatedTransp.tag}
                    onChange={e => {
                      setUpdatedTransp(old => {
                        return { ...old, tag: e.target.value }
                      })
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setModalUpdateTransp(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="submit"
            form="updateTransp"
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
    </>
  )
}

ListaTransportadoras.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(ListaTransportadoras)
